import { useSelector } from 'react-redux';

import type { AddToCartState } from '@/domains/shoppingCart/AddToCart/AddToCart.interfaces';

import { selectAddToCartState } from '../AddToCart/selectors/selectAddToCartState';
import type { SpartacuxShoppingCartState } from '../ShoppingCartState';

export const useAddedToCartModal = () =>
  useSelector<SpartacuxShoppingCartState, AddToCartState | undefined>(
    selectAddToCartState,
  );
